import HeaderPages from "./HeaderPages";

export default HeaderPages;